import { render, staticRenderFns, recyclableRender, components } from "./trace.vue?vue&type=template&id=54f8c95b&"
var renderjs
import script from "./trace.vue?vue&type=script&lang=js&"
export * from "./trace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../下载/Edge下载/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/order/trace.vue"
export default component.exports